import Svg from "@/components/base/Svg"
import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { isEmpty } from "lodash"

const Container = styled.div`
    display: flex;
    align-items: center;
    display: flex;
    padding: 16rem;
    justify-content: center;
    border-radius: 8rem;
    border: 1rem solid #85b6ff;
    background-color: #d6e7ff;
    margin-bottom: 16rem;
    height: 64rem;
    overflow: hidden;
    svg {
        width: 32rem;
        height: 32rem;
    }
`

const Text = styled.div`
    font-family: Gilroy;
    color: #005ae0;
    font-size: 12rem;
    font-style: normal;
    font-weight: 400;
    line-height: 16rem;
    padding-right: 12rem;
    flex: 1;
`

export default function PagcorRequirements({ text = "" }: { text: string }) {
    if (isEmpty(text)) {
        return null
    }
    return (
        <Container>
            <Text>{text}</Text>
            <Svg src="pages/UserCenterPage/warning.svg" />
        </Container>
    )
}
